import {
  getLastBrokerRechargeOrder,
  postRedoLastBrokerRechargeOrder,
  postUploadBrokerRechargeImportFile,
} from '@/services/rechargesServices'
import { Broker } from './Broker'

const BrokerOtimo = new Broker({
  brokerName: 'Ótimo',
  getLastOrder: getLastBrokerRechargeOrder,
  uploadOrderFile: postUploadBrokerRechargeImportFile,
  redoLastOrder: postRedoLastBrokerRechargeOrder,
  modelFileUrl: process.env.REACT_APP_IMPORT_BROKER_RECHARGE_ORDER_FILE_MODEL_URL,
})

export default BrokerOtimo
